import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";

import { Button } from "components/atoms/button/index";
import { EmailField, PasswordField, whichRedirectDomains } from "./constants";
import { UserService } from "core/service/user.service";
import { AuthService } from "core/service/auth.service";
import { Config } from "core/service/config.service";
import { Field } from "components/molecules/Field";
import { UtilService } from "core/utils/utils";
import { BsEyeFill, BsEyeSlashFill } from "react-icons/bs";
import * as S from "./signin.styles";

export const SignInForm = () => {
  const { t } = useTranslation();
  const [showText, setShowText] = useState(false);
  const [affiliate, setAffiliate] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: "onBlur" });

  useEffect(() => {
    const affiliate = AuthService.getAffiliateDetails();
    setAffiliate(affiliate);
  }, []);

  const onSubmit = (values) => {
    let request = values;
    request.affiliate = affiliate.aff_id;
    values.affiliateName = affiliate.aff_name;
    UserService.signin(request).then((res) => {
      if (res && Object.keys(res.payload).length) {
        onSigninSuccess(res);
      }
    });
  };

  const onSigninSuccess = (values) => {
    AuthService.setSessionid(values.payload.sessionid);
    redirectToSimpletaxEdit();
  };

  const redirectToSimpletaxEdit = () => {
    const redirectUrl = whichRedirectDomains
      ? whichRedirectDomains
      : Config.getRedirectUrl();
    window.location.replace(`${redirectUrl}`);
  };

  return (
    <div>
      <S.CardBody>
        <S.Form onSubmit={handleSubmit(onSubmit)}>
          <S.LoginTitle>{t("signup.which.login_header")}</S.LoginTitle>
          <S.AccessInfo>{t("signup.which.access")}</S.AccessInfo>
          {EmailField.map((obj, index) => (
            <Field
              font="small"
              labelcolor="dark"
              {...obj}
              register={register}
              error={errors[obj.name]?.message}
              key={index}
            />
          ))}
          {PasswordField.map((obj, index) => (
            <div key={index}>
              <Field
                font="small"
                type={UtilService.setPasswordType(PasswordField, showText)}
                {...obj}
                register={register}
                error={errors[obj.name]?.message}
                key={index}
              />
              <S.EyeContainer>
                <S.Eye onClick={() => setShowText(!showText)}>
                  {showText ? <BsEyeFill /> : <BsEyeSlashFill />}
                </S.Eye>
              </S.EyeContainer>
            </div>
          ))}
          <S.ButtonClass>
            <S.ButtonContainer>
              <Button
                value={t("signIn.label.signin")}
                size="610"
                transform="capitalize"
                background="#66D7D1"
                hover="#7986CB"
              />
            </S.ButtonContainer>
            <S.RegisterWrap>
              <p>
                <Link to="/forgot-password">
                  {t("signIn.label.forgot_password")}
                </Link>
              </p>
            </S.RegisterWrap>
          </S.ButtonClass>
        </S.Form>
      </S.CardBody>
    </div>
  );
};
